import { Content } from '../../types';

export const generalVietnamContent: Content = {
  title: 'וייטנאם - תעודת זהות',
  imageUrl: '/images/vietnam/general-vietnam/general-vietnam-wide.jpeg',
  introduction:
    'הרפובליקה הסוציאליסטית של וייטנאם ממוקמת בדרום-מזרח אסיה, גובלת בסין בצפון, בלאוס וקמבודיה במערב ובים סין הדרומי במזרח ובדרום. וייטנאם משתרעת על פני כ-331,000 קמ"ר ומתגוררים בה למעלה מ-100 מיליון תושבים. בירת המדינה הינה האנוי, אך העיר הגדולה ביותר והמרכז הכלכלי הינה הו צ\'י מין סיטי (סייגון). השלטון בוייטנאם הינו קומוניסטי חד-מפלגתי ובראשו עומד הנשיא, לצד ראש ממשלה האחראי על ניהול המדינה.',
  sections: [
    {
      title: 'גיאוגרפיה ואקלים',
      type: 'text',
      content:
        'המדינה מתאפיינת בנופים מגוונים הכוללים רכסי הרים בצפון, דלתות נהרות עצומות, חופים טרופיים, מישורים פוריים ויערות גשם. שני נהרות מרכזיים משפיעים רבות על החיים בוייטנאם: המקונג בדרום, היוצר את דלתת המקונג הפורייה והנהר האדום בצפון, שסביבו התפתחה האנוי.<br /><br />לוייטנאם אקלים טרופי מונסוני, עם עונה גשומה בין מאי לאוקטובר ועונה יבשה בין נובמבר לאפריל. בצפון המדינה חורפים קרירים יותר, בעוד שבדרום מזג האוויר חם ולח לאורך כל השנה. התקופה המומלצת ביותר לביקור במדינה, הינה בין נובמבר למרץ, כאשר מזג האוויר נעים יחסית.',
    },
    {
      title: 'היסטוריה ותרבות',
      type: 'text',
      content:
        'וייטנאם בעלת היסטוריה עשירה של יותר מאלפיים שנה, בהשפעת התרבות הסינית, שליטתה של צרפת בתקופה הקולוניאלית (1862-1954) ומאבקיה לעצמאות. מלחמת וייטנאם (1955-1975) הייתה מהאירועים המכוננים בתולדות המדינה, כשלאחריה התאחדו צפון ודרום וייטנאם תחת שלטון קומוניסטי.<br /><br />התרבות הוייטנאמית משלבת מסורות קונפוציאניות, בודהיסטיות ומקומיות. הדת המרכזית הינה הבודהיזם, לצד דאואיזם, קונפוציאניזם ונצרות. המטבח הוייטנאמי מפורסם בטעמיו הטריים, עם מנות כגון פו (מרק אטריות), באן מי (כריך צרפתי-וייטנאמי) ו-גווי קואן (ספרינג רול טרי).',
    },
    {
      title: 'דתות ומטבע',
      type: 'text',
      content:
        'כאמור, וייטנאם הינה מדינה בעלת מגוון דתי רחב. הדת המרכזית הינה הבודהיזם, המהווה חלק בלתי נפרד מחיי היומיום, במיוחד בגרסתו התרוואדית ומהאיאנית. בנוסף, ישנן קהילות נוצריות גדולות (בעיקר קתוליות), וכן מאמינים בדאואיזם, קונפוציאניזם ובדתות מקומיות כמו הקאו דאי וההואה האו.<br /><br />המטבע הרשמי של וייטנאם הינו הדונג הוייטנאמי (VND), כאשר שערי המטבע משתנים בהתאם לתנודות הכלכלה והשווקים העולמיים.',
    },
    {
      title: 'כלכלה ופיתוח',
      type: 'text',
      content:
        'וייטנאם הינה אחת הכלכלות הצומחות ביותר בעולם, עם דגש על ייצור, חקלאות, תיירות וטכנולוגיה. ענף הייצוא המרכזי כולל טקסטיל, אלקטרוניקה, קפה ואורז. בשנים האחרונות, המדינה משכה השקעות זרות רבות, במיוחד בתחום התעשייה וההייטק.',
    },
    {
      title: 'אתרי תיירות בולטים',
      type: 'list',
      content: [
        {
          subtitle: 'האנוי',
          text: 'בירת וייטנאם, משלבת היסטוריה עשירה עם אווירה מודרנית.',
        },
        {
          subtitle: "הו צ'י מין סיטי",
          text: 'המרכז הכלכלי של המדינה, עם מוזיאונים היסטוריים וחיי לילה סוערים.',
        },
        {
          subtitle: 'הלונג ביי',
          text: 'מפרץ קסום עם אלפי איים קרסטיים, אתר מורשת עולמית של אונסק"ו.',
        },
        {
          subtitle: 'סאפה',
          text: 'אזור הררי בצפון המדינה, מפורסם בטרסות האורז ובתרבויות השבטים המקומיים.',
        },
        {
          subtitle: "הא ג'יאנג",
          text: 'עיירה מרכזית בצפון ההררי של וייטנאם, בסמוך לגבול וייטנאם - סין, ממנה יוצאים לטיולי לופ של מספר ימים בנופים המהממים של האזור.',
        },
        {
          subtitle: 'הוי אן',
          text: 'עיר עתיקה קסומה עם השפעות סיניות, יפניות וצרפתיות.',
        },
        {
          subtitle: 'הואה',
          text: 'בירתה ההיסטורית של וייטנאם, עם מצודת העיר הקיסרית וקברי קיסרים.',
        },
        {
          subtitle: 'דלתת המקונג',
          text: 'אזור כפרי עשיר בתעלות מים, שווקים צפים וחוות חקלאיות.',
        },
        {
          subtitle: 'פו קוק',
          text: 'אי טרופי עם חופים לבנים ואתרי נופש יוקרתיים.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, וייטנאם הינה מדינה דינמית ומרתקת, המציעה שילוב ייחודי של היסטוריה, טבע מרהיב, תרבות עשירה ואוכל יוצא דופן. עם כלכלה בצמיחה ותשתיות מתפתחות, מהווה וייטנאם יעד חובה לכל מטייל המחפש חוויה אותנטית בדרום-מזרח אסיה.',
    },
  ],
};
